import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import {
  Box,
  FormControl,
  FormControlProps,
  FormHelperText,
  TextField,
} from "@mui/material";

interface OptionType {
  key: string;
  value: string;
}

export interface CustomProps {
  handleChange: (value: Array<string>) => void;
  options: Array<OptionType>;
  selectedValues: Array<string>;
  id: string;
  label: string;
  placeHolder?: string;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  isLoading?: boolean;
  displayEmpty?: boolean;
  size?: FormControlProps["size"];
  maxWidth?: string | number;
  width?: string | number;
  disabled?: boolean;
}

// export type AutocompleteWithChipsProps = CustomProps
//   & AutocompleteProps<OptionType, true, false, false>;

export const AutocompleteWithChips: React.FC<CustomProps> = ({
  id,
  options = [],
  selectedValues,
  label,
  placeHolder = label,
  required = false,
  error = false,
  errorMessage,
  size = "medium",
  maxWidth = "100%",
  width = "100%",
  handleChange,
  disabled,
}) => {
  const selectedValuesMemo = React.useMemo(() => {
    return options.filter((option) => selectedValues.includes(option.key));
  }, [selectedValues, options]);

  const handleChangeLocal = (
    event: React.SyntheticEvent,
    value: OptionType[],
  ) => {
    handleChange(value.map((option) => option.key));
  };

  return (
    <Box
      sx={{
        minWidth: 180,
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        maxWidth: {
          xs: "100%",
          sm: "50%",
          md: maxWidth,
        },
        width,
      }}
    >
      <FormControl
        sx={{ height: size === "medium" ? "3.5rem" : "auto" }}
        size={size}
        error={error}
        required={required}
        fullWidth
      >
        <Autocomplete
          id={id}
          multiple
          options={options}
          getOptionLabel={(option) => option.value}
          value={selectedValuesMemo}
          onChange={handleChangeLocal}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                label={option.value}
                {...getTagProps({ index })}
                key={option.key}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label={label}
              placeholder={placeHolder}
              required={required}
              disabled={disabled}
            />
          )}
          filterSelectedOptions
          disabled={disabled}
        />
      </FormControl>
      {errorMessage && (
        <FormHelperText className="px-3.5 pt-0.5 !text-error-main">
          {errorMessage}
        </FormHelperText>
      )}
    </Box>
  );
};
